import { useState, useEffect, useCallback } from 'react';
import { Check, X } from 'lucide-react';

interface ToastData {
  message: string;
  type: 'success' | 'error';
}

let showToastFn: ((data: ToastData) => void) | null = null;

export function toast(message: string, type: 'success' | 'error' = 'success') {
  showToastFn?.({ message, type });
}

export function ToastContainer() {
  const [toastData, setToastData] = useState<ToastData | null>(null);
  const [visible, setVisible] = useState(false);

  const show = useCallback((data: ToastData) => {
    setToastData(data);
    setVisible(true);
    setTimeout(() => setVisible(false), 2500);
  }, []);

  useEffect(() => {
    showToastFn = show;
    return () => { showToastFn = null; };
  }, [show]);

  if (!toastData || !visible) return null;

  const isSuccess = toastData.type === 'success';

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[100] animate-fade-in">
      <div className={`
        flex items-center gap-2 px-4 py-3 rounded-lg border text-sm font-mono backdrop-blur-xl
        ${isSuccess
          ? 'bg-[#3DBF7A]/[0.08] border-[#3DBF7A]/20 text-[#3DBF7A] shadow-[0_0_20px_rgba(61,191,122,0.06)]'
          : 'bg-[#E84040]/[0.08] border-[#E84040]/20 text-[#E84040] shadow-[0_0_20px_rgba(232,64,64,0.06)]'
        }
      `}>
        {isSuccess ? <Check className="w-4 h-4" /> : <X className="w-4 h-4" />}
        {toastData.message}
      </div>
    </div>
  );
}
